import {createAsyncThunk} from '@reduxjs/toolkit';
import {pickBy} from 'lodash';
import {IParams} from "../../../shared/shared-interfaces";
import axios from '../../../shared/config/axios-interceptor';
import {ISite} from "../../../shared/model/site.model";

const prefix = 'sites';
export const getEntities = createAsyncThunk(`get-all-${prefix}`, async (body: IParams, thunkAPI) => {
    try {
        const params = pickBy(body);
        return await axios.get<ISite[]>(`admin/${prefix}`, {params});
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

export const getEntity = createAsyncThunk(`get-single-${prefix}`, async (site_id: string, thunkAPI) => {
    try {
        const {data} = await axios.get<ISite>(`${prefix}/${site_id}`);
        return data;
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

export const updateEntity = createAsyncThunk(`update-one-${prefix}`, async (body: ISite, thunkAPI) => {
    try {
        const {site_id} = body;
        const {data} = await axios.put<ISite>(`admin/${prefix}/${site_id}`, body);
        return data;
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

export const createEntity = createAsyncThunk(`create-one-${prefix}`, async (body: ISite, thunkAPI) => {
    try {
        const {data} = await axios.post(`admin/${prefix}`, body);
        return data;
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

export const removeEntity = createAsyncThunk(`delete-one-${prefix}`, async (id: string, thunkAPI) => {
    try {
        await axios.delete(`admin/${prefix}/${id}`);
        return id;
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});
